var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('table-render',{attrs:{"schema":_vm.schema,"rows":_vm.rows,"actions":_vm.actions}}),_c('modal-detail-priority')],1)}
var staticRenderFns = []

export { render, staticRenderFns }